<main class="main-home-secton">
  <div class="infra-dev2">
    <img class="banner-img" src="/assets/images/iniatives-bg-image.png" alt="" />
    <div class="container">
      <div class="text-center">
        <h2 class="banner-head">Initiatives for Incubators</h2>
      </div>
    </div>
  </div>
  <section class="initive-first-section">
    <div>
      <div>
        <div>
          <div>
            <img class="maturity-img" src="/assets/images/maturity-headimg.png" alt="" />
            <h2 align="center">Tamilnadu Incubator Maturity Model 2.0</h2>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12 col-12">
              <div class="incubators-img-div">
                <p>
                  StartupTN has come up with an initiative to assess business
                  incubators across the State by meticulously identifying
                  various parameters and criteria to promote incubators
                  systematically by giving the incubators in the State with
                  maturity levels by following a Maturity Model. Maturity Models
                  are considered effective in assessing learning and knowledge
                  organizations for various levels. With an objective to develop
                  a framework for assessing incubators, a Panel of Experts with
                  rich experience as Heads of Incubators,Entrepreneurs, Mentors
                  and Investors was created.
                </p>
                <p>
                  The panel along with the StartupTN team has developed the
                  Tamil Nadu Maturity Model 2.0 framework to assess the maturity
                  level of incubators. This framework was developed based on
                  inputs from these experts as well as by studying similar
                  models used for incubators in India and abroad
                </p>
              </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 col-12 text-center">
              <img class="tnimm-image" src="/assets/images/Maturity-img.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="assessment-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" style="width: 70%">
          <div class="text-center home-title mb-3">
            <h1>TNIMM Assessment Domains</h1>
          </div>
          <div class="container mt-2">
            <div #widgetsContent class="initive-card-container middle">
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">1</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-1.png" alt="" />
                <p class="initive-card-cont" align="center">
                  Management Strategy
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">2</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-2.png" alt="" />
                <p class="initive-card-cont" align="center">Financial</p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">3</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-3.png" alt="" />
                <p class="initive-card-cont" align="center">
                  Knowledge & Expertise
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">4</div>
                <img class="asscard-img" style="justify-content: center" src="assets/images/ass-cardimg-4.png" alt="" />
                <p class="initive-card-cont" align="center">Human Resources</p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">5</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-5.png" alt="" />
                <p class="initive-card-cont" align="center">
                  Physical Infrastructure
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">6</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-6.png" alt="" />
                <p class="initive-card-cont" align="center">
                  Networking Ecosystem
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">7</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-7.png" alt="" />
                <p class="initive-card-cont" align="center">Social Impact</p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">8</div>
                <img class="asscard-img" src="assets/images/ass-cardimg-8.png" alt="" />
                <p class="initive-card-cont" align="center">Result & Outcome</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center" style="margin: 2%">
        <a *ngIf="showLeftArrow" (click)="toggleRightArrows()"><img src="assets/images/arrow-right.png" alt="" /></a>

        <a *ngIf="!showLeftArrow" (click)="toggleLeftArrows()"><img src="assets/images/arrow-left.png" alt="" /></a>
      </div>
    </div>
  </section>

  <section class="scaleup-section">
    <div class="">
      <div class="container">
        <div class="div-header newdiv-header">
          <img class="scaluphead-img" src="/assets/images/maturity-headimg.png" alt="" />
          <h2 class="scaleup-head">Scaleup Incubators</h2>
        </div>
        <div class="div-contents">
          <div class="row">
            <div class="col-lg-5 col-md-12 col-sm-12 scaleup-card">
              <div class="incubators-div">
                <div class="image-container">
                  <div class="triangle"></div>
                  <img src="assets/images/scalup-new-image.png" alt="Your Image" />
                </div>
              </div>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12">
              <div class="incubators-img-div">
                <p>
                  Scaleup Incubator is the flagship capacity building program
                  for the Incubation CEOs/Managers of Tamil Nadu Incubators by
                  StartupTN in equipping them with the concepts and strategies
                  of Incubation Management.
                </p>
                <p>
                  The program is intended to equip Incubation architects with
                  the Tamil Nadu Incubator Maturity Model (TNIMM) and support
                  them in the self assessment of their incubators.
                </p>
                <p>
                  Support Incubation Managers in framing the sustainability
                  plans and policies for their incubators through expert
                  mentoring sessions; Equip TN Incubation Managers in various
                  Business Incubation Models and prepare them to build world
                  class incubators and Provide an opportunity for Incubation
                  Managers in visiting an International Innovation Ecosystem and
                  peer-learning.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="helpdesk-section">
    <div class="">
      <div class="container">
        <div class="div-header">
          <img class="scaluphead-img2" src="/assets/images/maturity-headimg.png" alt="" />
          <h2 class="hustle-head">IM Hustle</h2>
        </div>
        <div class="div-contents">
          <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12">
              <div class="incubators-img-div">
                <p>
                  IM Hustle - Incubation Managers Hustle is an initiative
                  intended to focus on internal networking sessions between the
                  Incubation managers which serves as a peer learning and
                  knowledge sharing forums.
                </p>
                <p>
                  IM Hustle programs bring on diversified perspectives of
                  Incubation managers through effective brainstorming
                  discussions on progressive initiatives. This provides
                  constructive feedback and critiques that aid in personal and
                  professional development.
                </p>
                <p>
                  IM Hustle is a form of Peer encouragement and support that
                  often boost motivation and self-confidence in tackling
                  challenges or learning new skills. This program enables the
                  different viewpoints, experiences from every Incubation
                  manager thereby serving as an effective bridge between
                  Incubators functioning in different geography and sectors.
                </p>
              </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 col-12 scaleup-card">
              <div class="incubators-div">
                <div class="image-container">
                  <div class="triangle"></div>
                  <img src="assets/images/hustle-new-image.png" alt="Your Image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="helpdesk-section">
    <div class="">
      <div class="container">
        <div class="div-header">
          <img class="scaluphead-img3" src="/assets/images/maturity-headimg.png" alt="" />
          <h2 class="helpdesk-head">IM Helpdesk</h2>
        </div>
        <div class="div-contents">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 helpdesk-card">
              <div class="incubators-div">
                <div class="image-container">
                  <img src="assets/images/helpdesk-new-mainimage.png" alt="Your Image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="prodcast-section">
    <div class="container">
      <div class="">
        <img class="prodcast-img" align="center" src="/assets/images/maturity-headimg.png" alt="" />
        <h2 class="prodcast-head" align="center">IM Podcast</h2>
      </div>
      <div class="row">
        <div class="col-lg-7 col-md-12 col-sm-12">
          <div class="container left-info">
            <div class="prod-details">
              <p>
                Incubation Managers Podcast is an initiative to showcase the
                Incubators of Tamil Nadu especially those located in Tier II,
                III cities and Rural areas of the state.
              </p>
              <p>
                In the IM Podcast, we dive deep into the world of startup
                incubation, exploring the minds and experiences of seasoned
                incubation managers, industry experts, and thought leaders.
              </p>
              <p>
                Our mission is to empower and inspire incubation managers,
                accelerators, and anyone involved in nurturing early-stage
                ventures by providing valuable knowledge, strategies, and best
                practices.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12 text-center">
          <img class="prod-images" src="assets/images/prodcast-newimg.png" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section class="scaleup-section">
    <div class="">
      <div class="container">
        <div class="div-header">
          <img class="maturity-img" src="/assets/images/maturity-headimg.png" alt="" />
          <h2 align="center">TamilNadu Startup Incubators Summit</h2>
        </div>
        <div class="div-contents">
          <p>
            Tamil Nadu Startup Incubators Summit is a dynamic gathering of
            industry leaders, seasoned experts, and visionaries in the field of
            entrepreneurship and innovation. This exclusive event aims to:
          </p>
        </div>
        <div>
          <div>
            <div class="submit-card-container">
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="submit-card card-1">
                  <img class="submit-img" src="/assets/images/submit-newimg-1.png" alt="" />
                  <p class="submit-card-head">Facilitate Knowledge Exchange</p>
                </div>
                <div class="submit-card card-2">
                  <p class="submit-card-head2">
                    Engage in thought-provoking discussions, sharing best
                    practices, and exploring innovative strategies to enhance
                    incubation programs
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="submit-card card-3">
                  <img class="submit-img" src="/assets/images/submit-newimg-2.png" alt="" />
                  <p class="submit-card-head">Networking Opportunities</p>
                </div>
                <div class="submit-card card-4">
                  <p class="submit-card-head2">
                    Connect with a diverse community of incubation managers,
                    fostering collaboration and the exchange of ideas.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="submit-card card-5">
                  <img class="submit-img" src="/assets/images/submit-newimg-3.png" alt="" />
                  <p class="submit-card-head">Insights from Experts</p>
                </div>
                <div class="submit-card card-6">
                  <p class="submit-card-head2">
                    Gain valuable insights from keynote speakers, successful
                    entrepreneurs, and influencers shaping the future of startup
                    ecosystems.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-footer class="iniative-footer-section"></app-footer>
</main>